export default (props) => (
  <div id="notfound">
    <div className="notfound"></div>
  </div>
);
